import React, {useCallback, useEffect, useState} from 'react';
import {Link, Paragraph} from '../../components/Common/common.styled';
import Header from '../../components/Header/Header';
import {
	Bold, Wrapper
} from './styled/Main.styled';
import Steps from '../../components/Steps';

const Main = () => {
	const [scroll, setScroll] = useState(false);

	const onScroll = useCallback(e => {
		e.target.scrollingElement.scrollTop === 0 ? setScroll(false) : setScroll(true);
	}, []);

	useEffect(() => {
		document.addEventListener('scroll', onScroll);
		return () => {
			document.removeEventListener('scroll', onScroll);
		};
	}, [onScroll]);
	return (
		<>
			<Header smallHeader={scroll} />
			<Wrapper >
				<Paragraph bottom="40px"><Bold>Если вы являетесь юридическим лицом, индивидуальным предпринимателем или самозанятым,</Bold> напишите нам, мы с вами свяжемся и обо всем договоримся <Link href="mailto:v.zharkova@zaycev.net">legal@zaycev.net</Link></Paragraph>
				<Paragraph bottom="40px"><Bold>Если вы являетесь физическим лицом,</Bold> то для заключения лицензионного соглашения необходимо выполнить следующие шаги:</Paragraph>
				<Steps />
				<Paragraph bottom="40px">
					<Paragraph bottom="15px"><Bold>Предупреждаем вас о рисках уголовного и судебного преследования в случаях:</Bold></Paragraph>
					<Paragraph bottom="15px">Если песни, которые вы нам присылаете для размещения на музыкальном сервисе написаны с участием некоммерческих аккаунтов нейросетей. В этом случае права на сгенерированное содержание принадлежат авторам самой нейросети, компании-разработчику.</Paragraph>
					<Paragraph bottom="15px">Если голоса, которые используются при написании песен не ваши, а сгенерированы нейросетью, даже на коммерческой основе.</Paragraph>
					<Paragraph>Если вы решили нам загрузить не свои произведения.</Paragraph>
				</Paragraph>
			</Wrapper>
		</>
	);
};

export default Main;
